export const VALID_PRODUCT = 'Valid Product';
export const MISSING_INFO = 'Missing Info';
export const INVALID_FSN = 'Invalid FSN';
export const ALREADY_EXISTS = 'Exists on a Request';
export const THREED_AR_LIVE = '3D/AR Live';
export const INSTRUCTION_COMMENT = 'Add comment for any specific instructions or extra info';
export const VISUALIZE_PRODUCTS_SUBHEADING = 'Visualise Different Products and Pass or Fail';

export const DISPLAY_TEXT = {
    ALL_FSN_FAILED_ON_GUARDRAILS: 'All FSN are failed. Please check and try again'
};
